module.exports = __webpack_public_path__ + "media/images/CHA-10-1b0da5e07c80b15e94f72664c4aad5ed.jpg";